module.exports = __webpack_public_path__ + "img/soft-grove-kitchen-2.c044bb53.jpeg";